import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { SpecificationProviderEntrySchema } from './specification-provider.validator';

export const SpecificationEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    variation: z.string().optional().nullable(),
    provider: SpecificationProviderEntrySchema.optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
